module.exports = __webpack_public_path__ + "img/cover.a643a112.jpg";